var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-container", { staticClass: "p-3" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { inline: "" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "經銷商" } },
                  [
                    _c("selectCompany", {
                      attrs: { id: _vm.condition.company_id },
                      on: {
                        "update:id": function ($event) {
                          return _vm.$set(_vm.condition, "company_id", $event)
                        },
                        onSelect: _vm.onSelectCompany,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c("selectClient", {
                      attrs: {
                        "client-id": _vm.condition.client_id,
                        "company-id": _vm.condition.company_id,
                      },
                      on: {
                        "update:clientId": function ($event) {
                          return _vm.$set(_vm.condition, "client_id", $event)
                        },
                        "update:client-id": function ($event) {
                          return _vm.$set(_vm.condition, "client_id", $event)
                        },
                        onSelect: _vm.onSelectClient,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c("selectUser", {
                      attrs: { "user-id": _vm.condition.user_id },
                      on: {
                        "update:userId": function ($event) {
                          return _vm.$set(_vm.condition, "user_id", $event)
                        },
                        "update:user-id": function ($event) {
                          return _vm.$set(_vm.condition, "user_id", $event)
                        },
                        onSelect: _vm.onSelectUser,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {},
        [
          _c(
            "l-map",
            {
              ref: "myMap",
              staticStyle: {
                height: "85vh",
                position: "absolute",
                bottom: "0",
              },
              attrs: {
                center: { lat: 24.72573174017737, lng: 121.44913845558791 },
                zoom: 10,
              },
            },
            [
              _c("l-tile-layer", { attrs: { url: _vm.osmURL } }),
              _c(
                "v-marker-cluster",
                {
                  attrs: {
                    options: {
                      spiderLegPolylineOptions: _vm.spiderLegPolylineOptions,
                      maxClusterRadius: 80,
                    },
                  },
                },
                _vm._l(_vm.mvmsFilter, function (m, index) {
                  return _c(
                    "l-marker",
                    {
                      key: index,
                      attrs: { "lat-lng": [m.locate.lat, m.locate.lng] },
                    },
                    [
                      _c(
                        "l-icon",
                        {
                          attrs: {
                            "icon-size": [48, 48],
                            "icon-url": _vm._f("iconFilter")(m.Status),
                          },
                        },
                        [
                          _c("div", { staticClass: "headline text-center" }, [
                            _vm._v(" " + _vm._s(m.AssetNo) + " "),
                          ]),
                          _c("img", {
                            attrs: { src: _vm._f("iconFilter")(m.Status) },
                          }),
                        ]
                      ),
                      _c("l-popup", [
                        _c("div", { staticClass: "p-2 info-window" }, [
                          _c("h3", { staticClass: "m-0" }, [
                            _vm._v("資產代號: " + _vm._s(m.AssetNo)),
                          ]),
                          _c("h4", { staticClass: "m-0" }, [
                            _vm._v("客戶: " + _vm._s(m.client.name)),
                          ]),
                          _c("h4", { staticClass: "m-0" }, [
                            _vm._v("地址: " + _vm._s(m.locate.name)),
                          ]),
                          _c(
                            "h4",
                            [
                              _vm._v(" 目前狀態: "),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    effect: "dark",
                                    type: _vm._f("statusColorFilter")(m.Status),
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("statusFilter")(m.Status)
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }